export default __webpack_public_path__ + "static/media/survicate.0205deed.svg";